import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const Menu = styled.div`
  width: 100vw;
  height: 100vh;

  top: 0;
  left: 0;
  position: fixed;

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: ${(props) => `${props.theme.colors.black}4d`};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 24px;
`
